


















































import { defineComponent, ref, PropType } from '@vue/composition-api';

import { requiredValidator } from '@/utils/validators';

import { ALForm } from '@/common/component.types';
import { ISystemError } from '@/models';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';
import { useVModel } from '@vueuse/core';

export default defineComponent({
  name: 'QuoteLanguageSelector',

  components: {
    ConfirmationDialog
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Select Language'
    },
    message: {
      type: String,
      default: 'Please select a language for the quote.'
    },
    error: {
      type: [Object, Error] as PropType<ISystemError | null>,
      default: () => null,
      required: false
    },
    actionText: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    }
  },
  setup(props, { emit }) {
    const isDialogActive = useVModel(props, 'dialog', emit);

    const language = ref('en');
    const languageOptions = [
      {
        value: 'en',
        text: 'English'
      },
      {
        value: 'es',
        text: 'Spanish'
      },
      {
        value: 'ru',
        text: 'Russian'
      }
    ];
    const isFormValid = ref(false);

    const form = ref<ALForm>();

    function validateForm(): boolean {
      let valid = false;
      if (form.value) {
        valid = form.value.validate();
      }
      return valid;
    }

    function save() {
      if (validateForm()) {
        emit('save', language.value);
      }
    }

    return {
      isDialogActive,
      save,
      form,
      language,
      languageOptions,
      isFormValid,
      requiredValidator
    };
  }
});
